module.exports = __webpack_public_path__ + "static/media/3.0c23d8f0.png";